export default __webpack_public_path__ + "static/media/file-project.259bb18e.svg";